import React from 'react';
import PropTypes from 'prop-types';
import { LuCheck } from 'react-icons/lu';

const TONES = {
  amber: 'tw-border-amber-500/30 tw-bg-amber-400/15 tw-text-amber-800 dark:tw-border-amber-400/30 dark:tw-text-amber-200',
  violet: 'tw-border-violet-500/30 tw-bg-violet-500/10 tw-text-violet-800 dark:tw-border-violet-400/30 dark:tw-text-violet-200',
  teal: 'tw-border-teal-500/30 tw-bg-teal-500/10 tw-text-teal-800 dark:tw-border-teal-400/30 dark:tw-text-teal-200',
};

/**
 * On/off quick filter shown as a pill (e.g. "Bitişi yaklaşanlar"). `count`
 * shows how many records it would leave; `tone` colours the pressed state.
 */
const ToggleChip = ({ pressed, onChange, icon: Icon, label, count, title, tone = 'teal' }) => (
  <button
    type="button"
    aria-pressed={pressed}
    onClick={() => onChange(!pressed)}
    title={title}
    className={`tw-inline-flex tw-h-8 tw-items-center tw-gap-1.5 tw-rounded-full tw-border tw-px-3 tw-text-xs tw-font-semibold tw-transition-colors focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-teal-500/50 ${
      pressed
        ? TONES[tone]
        : 'tw-border-slate-200 tw-bg-white/60 tw-text-slate-600 hover:tw-bg-white hover:tw-text-slate-900 dark:tw-border-white/10 dark:tw-bg-white/[0.04] dark:tw-text-slate-300 dark:hover:tw-bg-white/[0.08] dark:hover:tw-text-white'
    }`}
  >
    {pressed ? <LuCheck aria-hidden="true" className="tw-h-3.5 tw-w-3.5" /> : Icon && <Icon aria-hidden="true" className="tw-h-3.5 tw-w-3.5" />}
    {label}
    {count !== undefined && (
      <span className="tw-rounded-full tw-bg-slate-900/[0.07] tw-px-1.5 tw-py-px tw-text-[10px] tw-font-bold tw-tabular-nums dark:tw-bg-white/10">
        {count}
      </span>
    )}
  </button>
);

ToggleChip.propTypes = {
  pressed: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  icon: PropTypes.elementType,
  label: PropTypes.string.isRequired,
  count: PropTypes.number,
  title: PropTypes.string,
  tone: PropTypes.oneOf(Object.keys(TONES)),
};

export default ToggleChip;
